function ESLTU() {
  return (
    <div>
      <h1>ESLTU</h1>
      {/* <p>Here's some of the Tenant Unions we're currently working with. Click to see how you can help with our efforts!</p> */}
    </div>
  );
}

export default ESLTU;